import { Icon, IconProps } from '../Icon'

export const ExitIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      exit_to_app
    </Icon>
  )
}
